const price = '฿34,999.-'
const facebookPage = 'https://www.facebook.com/pdpapro'
const tel = 'tel:020245560'

export default {
  price,
  facebookPage,
  tel,
}
